import { useAccount, useMsal } from "@azure/msal-react";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import type { ChatVectorIndexOption } from "src/db";
import { getAPI } from "src/utils/fetch";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL;

export async function fetchDatasources(instance): Promise<ChatVectorIndexOption[]> {
    const response = await getAPI({
        url: `${BACKEND_URL}/v1/search/datasources`,
        instance,
    });
    return await response.json();
}

export const useDatasources = (): UseQueryResult<ChatVectorIndexOption[], Error> => {
    const { instance } = useMsal();
    const account = useAccount();
    const isAuthenticated = !!account?.idToken;

    return useQuery<ChatVectorIndexOption[], Error>({
        queryKey: ["datasources"],
        queryFn: () => fetchDatasources(instance),
        enabled: isAuthenticated,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });
};
